// Logo.tsx
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Colors from '../global/Colors';
import Fonts from '../global/Fonts';
import { Link } from 'react-router-dom';

const LogoRoot = styled.div<{ $size: number, $hasOnClick?: boolean, $textAlignment: 'left' | 'right' | 'up' | 'down' | null }>`
  position: relative;
  display: flex;
  flex-direction: ${({ $textAlignment }) => $textAlignment === 'up' || $textAlignment === 'down' ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  gap: ${({ $size }) => $size/3}px;
  cursor: ${({ $hasOnClick }) => $hasOnClick ? 'pointer' : 'default'};
`;

const TextContainer = styled.div<{ $size: number, $caps?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: ${(props) => props.$size}px;
  font-weight: ${(props) => {
    if (props.$caps) {
      return props.$size > 48 ? Fonts.lexendMedium.fontWeight : Fonts.lexendLight.fontWeight;
    } else {
      return props.$size > 48 ? Fonts.lexendUltraBold.fontWeight : Fonts.lexendSemiBold.fontWeight;
    }
  }};
  font-family: ${Fonts.lexendBold.fontFamily};
  letter-spacing: ${(props) => props.$size > 48 ? `-0.05em` : `auto`};
  line-height: 1em;
  user-select: none;
`;

const PlayMix = styled.span<{ $colorMode?: 'light' | 'dark', $caps?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${({ $colorMode }) => $colorMode === 'dark' ? Colors.white : Colors.black};
  text-transform: ${({ $caps }) => $caps ? 'uppercase' : 'none'};
`;

const AI = styled.span<{ $colorMode?: 'light' | 'dark', $caps?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${({ $colorMode }) => $colorMode === 'dark' ? Colors.grey4 : Colors.grey6};
  text-transform: ${({ $caps }) => $caps ? 'uppercase' : 'none'};
`;

const Image = styled.img<{ $size: number }>`
  width: auto;
  height: ${(props) => props.$size}px;
`;

interface LogoProps {
    icon?: boolean;
    text?: 'left' | 'right' | 'up' | 'down' | null;
    size?: number;
    colorMode?: 'light' | 'dark';
    colorless?: boolean;
    ai?: boolean;
    caps?: boolean;
    onClick?: () => void;
}

const Logo: FunctionComponent<LogoProps> = ({ icon=true, text=null, size=24, colorMode='light', colorless=false, ai=true, caps=false, onClick }) => {
    const lightLogoColor = '/logo-color.png';
    const lightLogo = '/logo.png';
    const darkLogoColor = '/logo-dark-color.png';
    const darkLogo = '/logo-dark.png';

    const getImg = () => {
        if (colorless) {
            return colorMode === 'light' ? lightLogo : darkLogo;
        } else {
            return colorMode === 'light' ? lightLogoColor : darkLogoColor;
        }
    };

    const renderText = () => {
      return (
        text && 
        <TextContainer $size={size*1.22} $caps={caps}>
            <PlayMix $colorMode={colorMode} $caps={caps}>playmix</PlayMix>
            {ai && <AI $colorMode={colorMode} $caps={caps}>.ai</AI>}
        </TextContainer>
      )
    };

    return (
        //   <Link to="/" style={{ textDecoration: 'none' }}> 
        <LogoRoot $size={size} $hasOnClick={!!onClick} $textAlignment={text} onClick={onClick}>
          {(text === 'left' || text === 'up') && renderText()}
          {icon && <Image 
                $size={size} 
                src={getImg()}
            />}
          {(text === 'right' || text === 'down') && renderText()}
        </LogoRoot>
        //   </Link>
    );
};

export default Logo;